import {defineStore} from 'pinia';

export const useCentralisedTemplatesStore = defineStore('centralised_templates', {

    state: function () {

        return {
            /**
             * Just the name of the zip files found on the server
             */
            centralisedTemplates: []
        };

    },

    actions: {

        setCentralisedTemplates(centralisedTemplates) {
            this.centralisedTemplates = centralisedTemplates;
        },
        getCentralisedTemplates() {
            return this.centralisedTemplates;
        },

    }

});
